import React, { useEffect, useState, useRef } from 'react';
import { MapPinIcon, MailIcon, PhoneIcon, WrenchIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Serviser } from '../../data/servisers';
import { useTranslation } from '../../lib/i18n';
interface ServiceCardProps {
  serviser: Serviser;
  index: number;
}
export function ServiceCard({
  serviser,
  index
}: ServiceCardProps) {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.2
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  const handleEmailClick = () => {
    window.location.href = `mailto:${serviser.email}`;
  };
  const handleServiceRequest = () => {
    const subject = en ? 'Service request' : ru ? 'Запрос на обслуживание' : 'Zahtev za servis';
    const body = en ? 'Hello,%0D%0A%0D%0AI would like to request service for D-TECH equipment.' : ru ? 'Здравствуйте,%0D%0A%0D%0AЯ хотел бы запросить обслуживание для оборудования D-TECH.' : 'Poštovani,%0D%0A%0D%0AŽelim da zatražim servis za D-TECH opremu.';
    window.location.href = `mailto:${serviser.email}?subject=${subject}&body=${body}`;
  };
  return <div ref={ref} className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
    transitionDelay: `${index * 100}ms`
  }} data-id="element-565">
      <div className={`bg-dark-surface border-2 rounded-xl p-6 cursor-pointer transition-all duration-300 ${expanded ? 'border-brand-yellow shadow-[0_0_18px_rgba(255,214,0,0.25)] scale-[1.02]' : 'border-dark-border hover:border-brand-yellow hover:shadow-[0_0_18px_rgba(255,214,0,0.25)] hover:scale-[1.02]'}`} onClick={() => setExpanded(!expanded)} data-id="element-566">
        <div className="flex items-start gap-4 mb-4" data-id="element-567">
          <div className="w-12 h-12 bg-brand-yellow/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-568">
            <WrenchIcon className="w-6 h-6 text-brand-yellow" data-id="element-569" />
          </div>
          <div className="flex-1" data-id="element-570">
            <div className="flex items-center gap-2 mb-1" data-id="element-571">
              <MapPinIcon className="w-4 h-4 text-brand-yellow" data-id="element-572" />
              <h3 className="text-lg font-bold text-white" data-id="element-573">
                {en && (serviser as any).regionEn ? (serviser as any).regionEn : serviser.region}
              </h3>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-574">
              {ru && serviser.nameRu ? serviser.nameRu : serviser.name}
            </p>
          </div>
        </div>

        <div className="space-y-2 text-sm" data-id="element-575">
          <div className="flex items-center gap-2 text-gray-300" data-id="element-576">
            <MailIcon className="w-4 h-4 text-gray-500" data-id="element-577" />
            <span data-id="element-578">{serviser.email}</span>
          </div>
          {serviser.phone && <div className="flex items-center gap-2 text-gray-300" data-id="element-579">
              <PhoneIcon className="w-4 h-4 text-gray-500" data-id="element-580" />
              <span data-id="element-581">{serviser.phone}</span>
            </div>}
        </div>

        {expanded && <div className="mt-6 pt-6 border-t border-dark-border flex flex-col sm:flex-row gap-3 animate-fade-in" onClick={e => e.stopPropagation()} data-id="element-582">
            <Button variant="primary" size="sm" className="flex-1" onClick={handleEmailClick} data-id="element-583">
              {en ? 'Send email' : ru ? 'Отправить email' : 'Pošaljite email'}
            </Button>
            <Button variant="secondary" size="sm" className="flex-1" onClick={handleServiceRequest} data-id="element-584">
              {en ? 'Request service' : ru ? 'Запросить сервис' : 'Zatražite servis'}
            </Button>
          </div>}
      </div>
    </div>;
}